import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import '../Register.css';
import hayatlogo from '../../assets/images/hayatlogo.jpg';
import emailicon from '../../assets/images/emailicon.jpg';
import hayatin from '../../assets/images/hayatin.jpg';
import asteriskicon from '../../assets/images/asteriskicon.jpg';
import google from '../../assets/images/google.jpg';
import facebook from '../../assets/images/facebook.jpg';
import ios from '../../assets/images/ios.jpg';
import axios from 'axios';


const Resetpassword = () => {

    const navigate = useNavigate();
    const location = useLocation();

    // Form state
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [errors, setErrors] = useState({
        email: "",
        otp: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isResendingOtp, setIsResendingOtp] = useState(false);
    const [resetpasswordotpverify, setResetPasswordOtpVerify] = useState([]);

    // Load email from localStorage or navigation state on mount
    useEffect(() => {
        const storedEmail = localStorage.getItem('resetPasswordEmail');
        const emailFromState = location.state?.email;

        if (emailFromState) {
            setEmail(emailFromState);
        } else if (storedEmail) {
            setEmail(storedEmail);
        }
    }, [location.state]);

    // Email validation
    const validateEmail = (email) => {
        if (!email.trim()) {
            return "Email is required";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return "Please enter a valid email address";
        }
        return "";
    };

    // OTP validation
    const validateOtp = (otp) => {
        if (!otp.trim()) {
            return "OTP is required";
        }
        // OTP should typically be numeric and have a minimum length
        if (!/^\d+$/.test(otp.trim())) {
            return "OTP must contain only numbers";
        }
        if (otp.trim().length < 4) {
            return "OTP must be at least 4 digits";
        }
        return "";
    };

    // Handle email input change
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        // Clear error when user starts typing
        if (errors.email) {
            setErrors(prev => ({ ...prev, email: "" }));
        }
    };

    // Handle OTP input change
    const handleOtpChange = (e) => {
        const value = e.target.value;
        setOtp(value);
        // Clear error when user starts typing
        if (errors.otp) {
            setErrors(prev => ({ ...prev, otp: "" }));
        }
    };

    // Validate all fields
    const validateForm = () => {
        const newErrors = {
            email: validateEmail(email),
            otp: validateOtp(otp)
        };

        setErrors(newErrors);

        // Check if there are any errors
        return !Object.values(newErrors).some(error => error !== "");
    };

    const fetchresetpasswordotpverify = async () => {
        // Validate form
        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        const payload = {
            email: email.trim(),
            otp: otp.trim()
        };

        try {
            const response = await axios.post(`http://localhost:8000/api/website/reset-password-otp-verify`, payload);
            setResetPasswordOtpVerify(response.data);
            console.log(response.data);

            // Store email and OTP in localStorage as backup
            localStorage.setItem('resetPasswordEmail', email.trim());
            localStorage.setItem('resetPasswordOtp', otp.trim());

            // Navigate to confirm password on success
            navigate('/confirm-password', { state: { email: email.trim(), otp: otp.trim() } });
        } catch (error) {
            console.log("Error Fetching the Reset password Otp", error);

            let errorMessage = "OTP verification failed. Please check your OTP and try again.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;

                // Check for specific field errors
                if (error.response.data.email) {
                    setErrors(prev => ({ ...prev, email: error.response.data.email }));
                }
                if (error.response.data.otp) {
                    setErrors(prev => ({ ...prev, otp: error.response.data.otp }));
                }
            }

            // Show general error if no specific field errors
            if (!error.response?.data?.email && !error.response?.data?.otp) {
                alert(errorMessage);
            }
        } finally {
            setIsLoading(false);
        }
    };


    const fetchresendforgotpasswordotp = async () => {
        // Validate email before resending
        const emailError = validateEmail(email);
        if (emailError) {
            setErrors(prev => ({ ...prev, email: emailError }));
            return;
        }

        setIsResendingOtp(true);
        const payload = {
            email: email.trim(),
        }
        try {
            const response = await axios.post(`http://localhost:8000/api/website/resend-forgot-password-otp`, payload);
            console.log(response.data);
            alert("OTP has been resent to your email. Please check your inbox.");
        } catch (error) {
            console.log("Error Fetching the Resend Forgot Password Otp", error);
            let errorMessage = "Failed to resend OTP. Please try again.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || error.response.data.error || errorMessage;
            }
            alert(errorMessage);
        } finally {
            setIsResendingOtp(false);
        }
    }

    // Handle form submit
    const handleSubmit = (e) => {
        e.preventDefault();
        fetchresetpasswordotpverify();
    };

    return (
        <div className="register-container">
            <div className="register-left">
                <img src={hayatlogo} alt="Register" />
            </div>

            <div className='register-right'>
                <div className='rightside-header'>
                    <img src={hayatin} alt='hayatin' />
                    <div className='signin-account'>
                        <p>Remember Your Password</p>
                        <Link to="/login" className="signin-link">
                            Sign In
                        </Link>
                    </div>
                </div>

                <div className='center-banner'>
                    <div className='register-heading'>
                        <h4>Reset Your Password</h4>
                    </div>

                    <div className='form-container'>

                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <h6>Email <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={emailicon} alt='emailicon' className="input-icon" />
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        placeholder="Enter Your Email"
                                        required
                                    />
                                </div>
                                {errors.email && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.email}</span>}
                            </div>
                            <div className="input-group">
                                <h6>Enter Code <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={asteriskicon} alt='asteriskicon' className="input-icon" />
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        value={otp}
                                        onChange={handleOtpChange}
                                        placeholder="Enter Your OTP"
                                        maxLength="6"
                                        required
                                    />
                                </div>
                                {errors.otp && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.otp}</span>}
                            </div>

                            <div className='resend-otp-container'>
                                <p 
                                    onClick={fetchresendforgotpasswordotp}
                                    style={{ 
                                        cursor: isResendingOtp ? 'not-allowed' : 'pointer',
                                        opacity: isResendingOtp ? 0.6 : 1,
                                        userSelect: 'none'
                                    }}
                                >
                                    {isResendingOtp ? "Resending OTP..." : "Resend OTP"}
                                </p>
                            </div>

                            <div className='createaccount-button'>
                                <button
                                    type="submit"
                                    className="create-account-btn"
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Verifying..." : "Submit"}
                                </button>
                            </div>

                        </form>
                        <div className="divider">
                            <hr /><p>Continue With</p><hr />
                        </div>
                        <div className='socialicon'>
                            <img src={google} alt='google' />
                            <img src={facebook} alt='facebook' />
                            <img src={ios} alt='ios' />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}


export default Resetpassword